// extracted by mini-css-extract-plugin
export var deleteModal = "_ra-0";